export const accountApi = {
  bindingStatus: () => ({ url: 'v2/:clientId/account-binding/status', method: 'get' }),
  applyBinding: ({ provider, username, password, email, countryCode, phone, loginType, additionalUserInfo, isSignature }) => ({
    url: 'v2/:clientId/account-binding/bind',
    method: 'post',
    params: { provider, username, password, email, countryCode, phone, loginType, additionalUserInfo, isSignature },
  }),
  acknowledge: ({ request_id, code }) => ({ url: 'v2/:clientId/account-binding/acknowledge', method: 'post', params: { request_id, code } }),
  bindThirdParty: (data) => ({ url: 'v2/:clientId/account-binding/bind-third-party', method: 'get', params: data }),
  bindPassword: ({ password }) => ({ url: 'v2/:clientId/account-binding/bind-password', method: 'post', params: { password } }),
  resetOtp: ({ request_id }) => ({ url: 'v2/:clientId/account-binding/reset-otp', method: 'post', params: { request_id } }),
}
